module.exports = __webpack_public_path__ + "assets/images/p3_761d19f7da96d2772d6cc84854bf4826.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/packs/p3.png
// module id = 127
// module chunks = 0